import { createSlice } from "@reduxjs/toolkit";
import { ALL_ACTIVITY } from "../../../constants/reducer_names";


const initialState = {
    missedCount: [] as any,
    navigate:false as boolean,
    sessionData:[] as any,
    supervisorCount:0,
    reAssignCount:0,
    assignCount:0,
    activityLength:false as boolean,
}

const allActivitySlice = createSlice({
    name:ALL_ACTIVITY,
    initialState,
    reducers:{
        stateVal:(state,{payload}) => {
            state.missedCount.push(payload.missedCount);
            state.navigate= payload.navigate;
            state.sessionData.push(payload.sessionData);
        },
        setSuperVisorVal:(state) => {
            state.supervisorCount+=1
        },
        setReAssignCount:(state) => {
            state.reAssignCount+=1
        },
        reset:(state)=>{
            state.missedCount=[]
            state.supervisorCount=0
        },
        assignCount:(state,{payload}) => {
            state.assignCount=payload
        },
        activityLength:(state,{payload}) => {
            state.activityLength=payload
        },
    }
})

export const allActivityActions = allActivitySlice.actions;
export const allActivityReducers = allActivitySlice.reducer;